export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8623.494565fb.jpg";